export const capitalizeAllWords = (string) => {
  if (!string) return string;
  return string
    .split(/[_ ]/) // Split by either underscore or space
    .map((word) => word.toUpperCase())
    .join(" ");
};
